import clsx from "clsx";
import Link from "next/link";
import React, { AnchorHTMLAttributes } from "react";

export type AProps = {
  href: string;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

export const A: React.FC<AProps> = ({ className, ...props }) => {
  return (
    <Link
      className={clsx(
        "text-blue-600 hover:underline dark:text-blue-400",
        className,
      )}
      {...props}
    />
  );
};
